import { ReactNode } from "react";

import TableCard from "components/Table/TableCard";

import { TTabItem } from "components/Layout/Navbar/Tab/types";
import {
  TPagination,
  TSort,
  TTabeField,
  TTableRecord,
} from "components/Table/types";

export interface TableWrapperProps {
  loading?: boolean;
  title?: React.ReactNode;
  tabs?: TTabItem;
  selectedTab?: string;
  records?: TTableRecord[];
  pagination?: TPagination;
  hasCheckbox?: boolean;
  selectedRows?: string[];
  isSelectedAllPage?: boolean;
  mainAction?: React.ReactNode;
  fields?: TTabeField[];
  action?: React.ReactNode;
  emptyLabel?: string;
  emptyIcon?: React.ReactNode;
  classNameEmptyIconContainer?: string;
  hasFilter?: boolean;
  topLeftIcon?: ReactNode;
  keyId?: string;
  containerClassName?: string;
  onChangePage?: (page: number) => void;
  onChangePerPage?: (perPage: number) => void;
  onSort?: (sort: TSort) => void;
  onChangeTab?: (key: string) => void;
  onRowChecked?: (selectedIds: string[]) => void;
  onRowClick?: (id: string) => void;
  onSelectAllCurrentPage?: (checked: boolean) => void;
  onSelectAllPage?: (isSelectAll: boolean) => void;
}

const TableWrapper = ({
  loading,
  tabs,
  title,
  topLeftIcon,
  selectedTab,
  records = [],
  pagination,
  hasCheckbox,
  selectedRows,
  isSelectedAllPage,
  mainAction,
  fields = [],
  action,
  emptyLabel,
  emptyIcon,
  classNameEmptyIconContainer,
  hasFilter,
  keyId = "id",
  containerClassName,
  onRowClick,
  onChangePage,
  onChangePerPage,
  onSort,
  onChangeTab,
  onRowChecked,
  onSelectAllCurrentPage,
  onSelectAllPage,
}: TableWrapperProps) => {
  return (
    <div className="w-full">
      <TableCard
        title={title}
        keyId={keyId}
        loading={loading}
        tabs={tabs}
        topLeftIcon={topLeftIcon}
        hasCheckbox={hasCheckbox}
        selectedTab={selectedTab}
        mainAction={mainAction}
        action={action}
        fields={fields}
        records={records}
        pagination={pagination}
        selectedRows={selectedRows}
        isSelectedAllPage={isSelectedAllPage}
        hasFilter={hasFilter}
        emptyIcon={emptyIcon}
        emptyLabel={emptyLabel}
        classNameEmptyIconContainer={classNameEmptyIconContainer}
        onChangePage={onChangePage}
        onChangePerPage={onChangePerPage}
        onSort={onSort}
        onRowClick={onRowClick}
        onChangeTab={onChangeTab}
        onRowChecked={onRowChecked}
        onSelectAllCurrentPage={onSelectAllCurrentPage}
        onSelectAllPage={onSelectAllPage}
        containerClassName={containerClassName}
      />
    </div>
  );
};

export default TableWrapper;
